<template>
  <div class="privacy-policy">
    <p class="intro">
      Questo documento descrive le politiche sulla privacy di <strong>Kinesis Club</strong>, redatte da <strong>Morgan Malavasi</strong>.
    </p>

    <img src="@/assets/icon.png" alt="Azienda Icon" class="azienda-icon" />
    <h1>Privacy Policy</h1>
    <p>
      La tua privacy è importante per noi. Questa politica sulla privacy descrive come raccogliamo, utilizziamo e
      proteggiamo i dati personali degli utenti della nostra app.
    </p>

    <h2>1. Tipi di Dati Raccolti</h2>
    <ul>
      <li><strong>Nome e Cognome</strong>: per identificare l'utente.</li>
      <li><strong>Data di nascita e luogo di nascita</strong>: per determinare l'età e garantire la conformità alle
        normative per i minori.</li>
      <li><strong>Indirizzo</strong>: per esigenze di identificazione e contatto.</li>
      <li><strong>Numero di cellulare (facoltativo)</strong>: per contattarti se necessario.</li>
      <li><strong>Email e password</strong>: per la creazione e la gestione dell'account utente.</li>
    </ul>

    <h2>2. Come Raccogliamo i Dati</h2>
    <p>I dati vengono raccolti attraverso il processo di registrazione dell'utente nell'app.</p>

    <h2>3. Utilizzo dei Dati</h2>
    <p>I tuoi dati sono utilizzati per:</p>
    <ul>
      <li>Creare e gestire il tuo account.</li>
      <li>Fornire e personalizzare la tua esperienza nell'app.</li>
      <li>Gestire la sicurezza dell'account.</li>
    </ul>

    <h2>4. Condivisione dei Dati</h2>
    <p>I tuoi dati non sono condivisi con terze parti, salvo quanto richiesto dalla legge o necessario per fornire i
      servizi tecnici (ad esempio, hosting dei dati).</p>

    <h2>5. Protezione dei Dati</h2>
    <p>Adottiamo misure di sicurezza per proteggere i tuoi dati personali, inclusa la crittografia delle password.</p>

    <h2>6. Conservazione dei Dati</h2>
    <p>Conserveremo i tuoi dati fintanto che il tuo account rimarrà attivo. Puoi richiedere la cancellazione dei tuoi
      dati in qualsiasi momento.</p>

    <h2>7. Diritti dell'Utente</h2>
    <p>Hai il diritto di accedere, correggere o cancellare i tuoi dati personali in qualsiasi momento.</p>

    <h2>8. Conformità alle Leggi</h2>
    <p>Rispettiamo tutte le normative sulla privacy applicabili, inclusi il GDPR e la COPPA, per garantire la protezione
      dei dati personali.</p>
  </div>
</template>

<script>
import icon from '@/assets/icon.png'

export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      icon
    }
  }
}
</script>

<style scoped>
.privacy-policy {
  font-family: Arial, sans-serif;
  padding: 20px;
  line-height: 1.6;
}

.intro {
  font-size: 14px;
  margin-bottom: 20px;
  color: #555;
}

.azienda-icon {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
}

h1 {
  color: #333;
}

h2 {
  color: #4CAF50;
}

ul {
  list-style-type: disc;
  margin-left: 20px;
}

p {
  margin-bottom: 10px;
}
</style>